import { Box, Text } from '@fairfashion/design-system'

import * as Styles from './invoice-data.styles'
import { InvoiceDataProps } from './invoice-data.types'

export const InvoiceData = ({ invoice }: InvoiceDataProps) => {
  return (
    <Styles.Container width="100%" flex={1} flexWrap="wrap">
      <Box justifyContent="space-between">
        <Box direction="column">
          <Text size="small" color="grey_3">
            Código
          </Text>
          <Text size="small" fontWeight={500}>
            {invoice?.code ?? ''}
          </Text>
        </Box>
        {/* <Box direction="column">
            <Text size="small" color="grey_3">
              Chave
            </Text>
            <Text size="small" fontWeight={500}>
              {invoice?.key ?? ''}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Data de emissão
            </Text>
            <Text size="small" fontWeight={500}>
              {invoice?.createDate ?? ''}
            </Text>
          </Box>
          <Box direction="column">
            <Text size="small" color="grey_3">
              Arquivo NF
            </Text>
            <a href={invoice?.file} target="_blank">
              <Text size="small" color="info" fontWeight={500}>
                {file}
              </Text>
            </a>
          </Box> */}
      </Box>
    </Styles.Container>
  )
}
